import React from 'react';
import { HiOutlineMenu } from 'react-icons/hi';
import { MdOutlineRadioButtonChecked } from 'react-icons/md';
import Logo from '../../img/Logo.png';

const Navbar = () => {
    const [open, setOpen] = React.useState(false);
    const [flyer, setFlyer] = React.useState(false);
    const [flyerTwo, setFlyerTwo] = React.useState(false);

    return (
        <div className=' fixed top-0 left-0 right-0 z-50 ' style={{ fontFamily: "Merienda" }}>

            <div className=" relative z-50 bg-[#EFE6DA] ">
                <div className="max-w-7xl mx-auto px-4 sm:px-6">
                    <div className=" flex justify-between items-center py-6 md:justify-start md:-pt-12 md:space-x-10">
                        <div className="flex justify-start lg:w-0 lg:flex-1">
                            <a href="#">

                                <img
                                    className="h-8 w-auto sm:h-10"
                                    src={Logo}
                                    alt=""
                                />
                            </a>
                        </div>
                        <div className="-mr-2 -my-2 md:hidden">
                            <button
                                type="button"
                                className=" rounded-md p-2 inline-flex items-center justify-center text-[#5c5c68] hover:text-[#E27900]  hover:bg-gray-100 "
                                onClick={() => setOpen(!open)}
                            >
                                <span className="sr-only">Open menu</span>
                                {/* Heroicon name: outline/menu */}
                                <HiOutlineMenu className='h-6 w-6f' />
                            </button>
                        </div>
                        <nav className="hidden md:flex space-x-10">
                            <div className="relative">
                                {/* Item active: "text-gray-900", Item inactive: "text-gray-500" */}
                                <button
                                    type="button"
                                    className="group text-[#5c5c68] inline-flex items-center text-base font-medium hover:text-[#E27900] delay-200  "
                                    onClick={() => (setFlyer(!flyer), setFlyerTwo(false))}
                                >
                                    <span>Menu</span>
                                    <svg
                                        className={
                                            flyer === true
                                                ? "transform rotate-180 ml-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 transition ease-out duration-200"
                                                : "transform rotate-0 transition ease-out duration-200 ml-2 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                        }
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </button>


                                <div
                                    onMouseLeave={() => setFlyer(false)}
                                    className={
                                        flyer
                                            ? " opacity-100 translate-y-0 transition ease-out duration-200 absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2"
                                            : " opacity-0 translate-y-1 absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2"
                                    }
                                >
                                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                                        <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">

                                            <a
                                                href="#"
                                                className="p-3 flex items-center rounded-lg hover:bg-gray-50"
                                            >
                                                {/* Heroicon name: outline/view-grid */}
                                                <MdOutlineRadioButtonChecked className='text-[#E27900]' />
                                                <div className="ml-4">
                                                    <p className="text-base font-medium text-gray-900">
                                                        Coffee
                                                    </p>
                                                </div>
                                            </a>
                                            <a
                                                href="#"
                                                className="p-3 flex items-center rounded-lg hover:bg-gray-50"
                                            >
                                                {/* Heroicon name: outline/view-grid */}
                                                <MdOutlineRadioButtonChecked className='text-[#E27900]' />
                                                <div className="ml-4">
                                                    <p className="text-base font-medium text-gray-900">
                                                        Milk
                                                    </p>
                                                </div>
                                            </a>
                                            <a
                                                href="#"
                                                className="p-3 flex items-center rounded-lg hover:bg-gray-50"
                                            >
                                                {/* Heroicon name: outline/view-grid */}
                                                <MdOutlineRadioButtonChecked className='text-[#E27900]' />
                                                <div className="ml-4">
                                                    <p className="text-base font-medium text-gray-900">
                                                        Cocktail
                                                    </p>
                                                </div>
                                            </a>
                                            <a
                                                href="#"
                                                className="p-3 flex items-center rounded-lg hover:bg-gray-50"
                                            >
                                                {/* Heroicon name: outline/view-grid */}
                                                <MdOutlineRadioButtonChecked className='text-[#E27900]' />
                                                <div className="ml-4">
                                                    <p className="text-base font-medium text-gray-900">
                                                        Tea
                                                    </p>
                                                </div>
                                            </a>
                                            <a
                                                href="#"
                                                className="p-3 flex items-center rounded-lg hover:bg-gray-50"
                                            >
                                                {/* Heroicon name: outline/view-grid */}
                                                <MdOutlineRadioButtonChecked className='text-[#E27900]' />
                                                <div className="ml-4">
                                                    <p className="text-base font-medium text-gray-900">
                                                        Cake
                                                    </p>
                                                </div>
                                            </a>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <a
                                href="#"
                                className="text-[#5c5c68]  text-base font-medium hover:text-[#E27900] delay-200 "
                            >
                                About
                            </a>
                            <a
                                href="#"
                                className="text-[#5c5c68]  text-base font-medium hover:text-[#E27900] delay-200"
                            >
                                Galleries

                            </a>
                            <a
                                href="#"
                                className="text-[#5c5c68]  text-base font-medium hover:text-[#E27900] delay-200"
                            >
                                News & Events

                            </a>
                            <a
                                href="#"
                                className="text-[#5c5c68]  text-base font-medium hover:text-[#E27900] delay-200 "
                            >
                                Contacts

                            </a>

                        </nav>
                        <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                            <a
                                href="#"
                                className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-base font-medium text-white bg-black hover:bg-transparent hover:text-black hover:bg-white delay-300"
                            >
                                Sign in
                            </a>
                            <a
                                href="#"
                                className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-base font-medium text-white bg-black hover:bg-transparent hover:text-black  hover:bg-white delay-300 "
                            >
                                Sign up
                            </a>
                        </div>
                    </div>
                </div>


                <div
                    className={
                        open
                            ? "opacity-100 scale-100 transition ease-out duration-200 absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
                            : "opacity-0 scale-95 absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
                    }
                >
                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                        <div className="pt-5 pb-6 px-5">
                            <div className="flex items-center justify-between">
                                <div>
                                    <img
                                        className="h-8 w-auto"
                                        src={Logo}
                                        alt="Workflow"
                                    />
                                </div>
                                <div className="-mr-2">
                                    <button
                                        type="button"
                                        className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 "
                                        onClick={() => setOpen(!open)}
                                    >
                                        <span className="sr-only">Close menu</span>
                                        {/* Heroicon name: outline/x */}
                                        <svg
                                            className="h-6 w-6"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            aria-hidden="true"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M6 18L18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                        </div>
                        <div className="py-6 px-5 space-y-6">
                            <div className="grid grid-cols-2 gap-y-4 gap-x-8">
                                <a
                                    href="#"
                                    className="text-[#5c5c68]  text-base font-medium hover:text-[#E27900] delay-200pb-8"
                                >
                                    About
                                </a>
                                <a
                                    href="#"
                                    className="text-[#5c5c68]  text-base font-medium hover:text-[#E27900] delay-200"
                                >
                                    Galleries

                                </a>
                                <a
                                    href="#"
                                    className="text-[#5c5c68]  text-base font-medium hover:text-[#E27900] delay-200"
                                >
                                    News & Events

                                </a>
                                <a
                                    href="#"
                                    className="text-[#5c5c68]  text-base font-medium hover:text-[#E27900] delay-200"
                                >
                                    Contacts

                                </a>
                            </div>
                            <div>
                                <a
                                    href="#"
                                    className=" whitespace-nowrap w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-base font-medium text-white bg-black hover:bg-transparent hover:text-black  hover:bg-white delay-300 "
                                >
                                    Sign up
                                </a>
                                <p className="mt-6 text-center text-base font-medium text-gray-500">
                                    Existing customer?
                                    <a href="#" className="text-[#E27900]  hover:text-[#E27900] ">
                                        Sign in
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;